// Per-service SEO overrides (meta tag only — does NOT change on-page copy).
// Looked up by slug in SeoHead.jsx; falls back to derived values when absent.
//   description → meta description + Service-schema description (aim 120–158 chars)
//   keywords    → meta keywords (commercial search terms)
//   title       → optional explicit <title> override (else auto-trimmed)
export const SERVICE_SEO = {
  "ai-readiness-and-adoption": {
    keywords:
      "AI readiness assessment, AI adoption consulting, responsible AI, AI strategy UK, generative AI readiness",
  },
  "digital-and-technology-transformation": {
    keywords:
      "digital transformation consulting, technology transformation UK, IT modernisation, target operating model, transformation strategy",
  },
  "project-programme-and-pmo-improvement": {
    keywords:
      "PMO consulting, PMO maturity assessment, programme management improvement, project delivery uplift, P3O",
  },
  "business-change-and-adoption": {
    description:
      "Change & adoption consulting: stakeholder engagement, impact assessment and readiness planning so your people adopt new ways of working — and it sticks.",
    keywords:
      "change management consulting UK, organisational change management, user readiness, business adoption, ways of working",
  },
  "service-and-operating-model-transformation": {
    keywords:
      "operating model design, target operating model consulting, service model transformation, organisation design, TOM",
  },
  "supplier-and-technology-value-optimisation": {
    keywords:
      "supplier optimisation consulting, IT contract optimisation, technology cost reduction, vendor management, software licensing review",
  },
  "it-service-management-and-operational-excellence": {
    description:
      "ITSM consultancy, ITIL-aligned — improve incident, problem, change and SLA maturity for stronger service reliability, user experience and operational control.",
    keywords:
      "ITSM consultancy UK, ITIL maturity assessment, service management improvement, incident and problem management, SLA and CSI",
  },
  "data-insight-and-performance": {
    description:
      "Data & performance consulting: sharpen KPIs, reporting, data quality and dashboards — plus AI data readiness — so leaders make faster, better-evidenced decisions.",
    keywords:
      "data and analytics consulting, KPI and reporting design, data quality, management dashboards, AI data readiness",
  },
  "benefits-realisation-and-assurance": {
    keywords:
      "benefits realisation consulting, benefits management, value assurance, business case benefits, benefits tracking",
  },
  "governance-and-delivery-control": {
    description:
      "Governance & delivery-control consulting: embed proportionate controls, assurance and decision gates that protect outcomes across complex change portfolios.",
    keywords:
      "governance consulting, delivery assurance, portfolio controls, decision gating, project assurance UK",
  },
  "capability-and-training-needs-analysis": {
    keywords:
      "training needs analysis, capability assessment, skills gap analysis, learning needs analysis, capability development",
  },
  "stakeholder-engagement-and-communications": {
    description:
      "Stakeholder engagement & communications consulting: structured engagement and comms that build understanding, momentum and trust across complex change.",
    keywords:
      "stakeholder engagement consulting, change communications, transformation comms plan, stakeholder management UK",
  },
};

export default SERVICE_SEO;
